module.exports = __webpack_public_path__ + "img/LV6.742e0dd7.webp";